<template>
  <router-link id="labSwitcher" :to="switchLink" :class="{'show' : $route.name === 'Lab'}">
    <span v-if="$route.name === 'Lab'">works</span>
    <span v-else>lab</span>
  </router-link>
</template>

<script>

import {mapGetters} from 'vuex'

export default {
  name: 'LabSwitcher',
  computed: {
    switchLink(){
      if (this.$route.name === 'Lab') return '/kenrig'
      
      return '/lab'
    },
    ...mapGetters({
      show: 'show'
    })
  },
}
</script>

<style lang="scss">
#labSwitcher{
  position: fixed;
  z-index: 140;
  top: var(--body-padding);
  right: var(--body-padding);
  width: 64px;
  height: 64px;
  border-radius: 50%;
  border: 2px solid var(--black);
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: var(--conduitITC);
  font-size: 1.4rem;
  font-weight: 500;
  color: var(--black);
  text-decoration: none;
  &.show{
    color: var(--white);
    border-color: var(--white);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LabSwitcher.vue